import { useState } from "react";
import { Link } from "react-router-dom";
import LogoBlue from "../assets/HD-Horizontal-Blue.png";
import Alert from "../components/Alert";
import { supabase } from "../lib/supabase";

const ResetPassword = () => {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [formState, setFormState] = useState({
    email: "",
  });
  const [loading, setLoading] = useState(false);

  async function resetPassword(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    
    const { error } = await supabase.auth.resetPasswordForEmail(formState.email, {
      redirectTo: window.location.origin + "/update-password",
    });
    setLoading(false);

    if (error) {
      setError(error.message);
      return;
    }

    setSuccess("Reset password link sent to your email");
  }

  return (
    <div className="flex items-center min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img className="mx-auto h-24 w-auto" src={LogoBlue} alt="HappyDoc" />
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" onSubmit={resetPassword}>
          <div>
            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                onChange={(e) => setFormState({ ...formState, email: e.target.value })}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-max-700 sm:text-sm sm:leading-6 pl-2"
              />
            </div>
          </div>

          <div>
            <button
              className="primary-button"
              type="submit"
              disabled={formState.email === "" || loading}
            >
              {loading ? "Sending..." : "Reset Password"}
            </button>
          </div>
          <p className="mt-10 text-center text-sm text-gray-500">
            Remember your password?{" "}
            <Link to="/login" className="font-semibold leading-6 text-max-700 hover:text-max-700">
              Sign in
            </Link>
          </p>
        </form>
        <div className="mt-4">{error && <Alert alertType="error" title="Error" description={error} />}</div>
        <div className="mt-4">{success && <Alert alertType="success" title="Success" description={success} />}</div>
      </div>
    </div>
  );
};

export default ResetPassword; 